// extracted by mini-css-extract-plugin
export default {"container":"wT3Ah","loader":"BVIvc"};